/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NINVerificationResponseDTO = {
    nationalIdentificationNumber?: string;
    resultText?: string;
    verificationStatus?: NINVerificationResponseDTO.verificationStatus;
};

export namespace NINVerificationResponseDTO {

    export enum verificationStatus {
        PENDING = 'PENDING',
        SUCCESS = 'SUCCESS',
        FAILED = 'FAILED',
    }


}

